import { LazyLoadImage } from 'react-lazy-load-image-component';
import Logo from '../img/Logo-Colegio.png';

const HeaderActa = () => {
    return (
      <header className="acta-header">
        <LazyLoadImage
          src={Logo}
          alt="Logo Gobe Campus"
          className="escudo"
          effect="blur"  // Opcional: efecto visual mientras la imagen carga
        />
        <div className="header-content">
          <h2>GOBE CAMPUS</h2>
          <p>Sistema de gestión educativa</p>
        </div>
        <LazyLoadImage
          src="https://upload.wikimedia.org/wikipedia/commons/e/ef/Coat_of_arms_of_Colombia.svg"
          alt="Escudo de Colombia"
          className="escudo"
          effect="blur"  // Opcional: efecto visual mientras la imagen carga
        />
      </header>
    );
  };
  
  export default HeaderActa;
  